import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";

const styles = {
  field: {
    width: "calc(100% - 180px)",
    display: "flex",
  },
};

export default function TextInput(props: TextFieldProps) {
  const [error, setError] = useState(props.error);

  useEffect(() => {
    setError(props.error);
  }, [props.error]);

  return (
    <TextField
      style={styles.field}
      id={props.id}
      label={props.label}
      variant={props.variant}
      helperText={props.helperText || (error ? "Invalid" : "")}
      {...props}
    />
  );
}
